import { render, staticRenderFns } from "./AwardBatch.vue?vue&type=template&id=01f4fbc0&scoped=true"
import script from "./AwardBatch.vue?vue&type=script&lang=js"
export * from "./AwardBatch.vue?vue&type=script&lang=js"
import style0 from "./AwardBatch.vue?vue&type=style&index=0&id=01f4fbc0&prod&lang=css"
import style1 from "./AwardBatch.vue?vue&type=style&index=1&id=01f4fbc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4fbc0",
  null
  
)

export default component.exports